import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import comm_imgs from "../../comm_imgs";
import { useTranslation } from "react-i18next";
import ApiGo from "../../actions/ApiGo";
import { useDispatch } from "react-redux";
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from "../../stores/reducer_add";
import Account from "../../actions/Account";
import ConfigHandler from "../../actions/ConfigHandler";

const RowPads = (props) => {
    const role = new Account().role;
    const ref = useRef();
    const refNumber = useRef();
    const refBedName = useRef();
    const p = props.p.data;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const store_pads_array = useSelector(state => state.store_beds.beds_array);
    // ✅ 重新計算 idRankMap，和 Pad.js 一致
    const idRankMap = {}
        ;[...store_pads_array]
            .sort((a, b) => a.id - b.id)
            // ✅ 新
            .forEach((pad) => {
                idRankMap[pad.mac] = pad.id
            })
    //const isCustomNumber = p.card_type && !isNaN(p.card_type) && String(p.card_type).trim() !== ""
    //const padNumberDisplay = isCustomNumber ? p.card_type : (p.padNumber ?? "-")
    const padNumberDisplay = p.reserved ?? "-";

    const [editPad, setEditPad] = useState(false);
    const [institutionName, setInstitutionName] = useState(p.institution ?? "");
    const [editNumber, setEditNumber] = useState(false);
    const [padNumberValue, setPadNumberValue] = useState(padNumberDisplay);
    const [editBedName, setEditBedName] = useState(false);
    const [bedName, setBedName] = useState(p.bed_name ?? "");

    useEffect(() => {
        if (editPad && ref.current) ref.current.focus();
    }, [editPad]);

    useEffect(() => {
        if (editNumber && refNumber.current) refNumber.current.focus();
    }, [editNumber]);

    useEffect(() => {
        if (editBedName && refBedName.current) refBedName.current.focus();
    }, [editBedName]);

    useEffect(() => {
        setInstitutionName(p.institution ?? "");
        setPadNumberValue(p.reserved ?? "-")
        setBedName(p.bed_name ?? "");
    }, [p.institution, p.reserved, p.bed_name]);

    function proccessName(e) {
        if (e.key === "Enter" || e === "Enter") {
            ApiGo.update_institution(p.mac, institutionName)
                .then(res => {
                    dispatch(ADD_RESPONSE({
                        status: 200,
                        statusText: "success",
                        type: "update_institution"
                    }));
                    dispatch(ADD_RESPONSE_JSON(res));
                    props.toggleRefresh();
                })
                .catch(err => {
                    dispatch(ADD_RESPONSE({
                        status: err.status,
                        statusText: err.statusText,
                        type: "update_institution"
                    }));
                    return err?.response;
                });

            setEditPad(false);
        }
    }

    function proccessNumber(e) {
        if (e.key === "Enter" || e === "Enter") {
            ApiGo.update_bed_number(p.mac, padNumberValue)
                .then(res => {
                    dispatch(ADD_RESPONSE({ status: 200, statusText: "success", type: "update_bed_number" }))
                    dispatch(ADD_RESPONSE_JSON(res))
                    props.toggleRefresh()
                })
                .catch(err => {
                    dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: "update_bed_number" }))
                })
            setEditNumber(false)
        }
    }

    function updateBedName() {
        ApiGo.update_bed_name(p.mac, bedName)
            .then(res => {
                dispatch(ADD_RESPONSE({ status: 200, statusText: "success", type: "update_bed_name" }));
                dispatch(ADD_RESPONSE_JSON(res));
                props.toggleRefresh();
            })
            .catch(err => {
                dispatch(ADD_RESPONSE({
                    status: err.status,
                    statusText: err.statusText,
                    type: "update_bed_name"
                }));
            });
        setEditBedName(false);
    }

    function proccessBedName(e) {
        if (e.key === "Enter" || e === "Enter") {
            props.setPop({
                open: true,
                content:
                    t("PAD.CONFIRM_UPDATE_BED_NAME") +
                    "【" + p.bed_name + "】" +   // 舊床號
                    " -> " +
                    "【" + bedName + "】" +      // 新床號(修改後的值)
                    " ?",
                parameter: [],
                callBack: updateBedName,
                title: t("GLOBAL.BED_NO")
            });
        }
    }

    function getWifiIcon(rssi) {
        if (rssi === null) return comm_imgs.WIFI_OFF;
        if (rssi < -70) return comm_imgs.WIFI_3;
        if (rssi < -60) return comm_imgs.WIFI_2;
        if (rssi < -50) return comm_imgs.WIFI_1;
        if (rssi >= -50) return comm_imgs.WIFI_FULL;
        return comm_imgs.WIFI_OFF;
    }

    const volumeMap = {
        30: t("RESIDENTS_SETTING.SENSOR.LARGE"),
        20: t("RESIDENTS_SETTING.SENSOR.MEDIUM"),
        15: t("RESIDENTS_SETTING.SENSOR.SMALL"),
        0: t("RESIDENTS_SETTING.SENSOR.SILENCE"),
    };

    return (
        <div className="pad-row-body">
            <div className="d-flex">
                {/* WIFI */}
                <div className="flex-grow-0 body-container">
                    <div className="body">
                        <div>
                            <img className="" src={getWifiIcon(p.rssi)} alt={t("GLOBAL.WIFI")} />
                        </div>
                    </div>
                </div>
                {/* 音量 */}
                <div className="flex-grow-0 body-container">
                    {p.volume === null
                        ? t("NAV_BAR.DISCONNECT") || "斷線中"
                        : volumeMap[p.volume] || "未知"}
                </div>
                {/* 單位 */}
                <div className={`flex-grow-1 body-container ${editPad ? "editBg" : ""}`} onKeyDown={proccessName} style={{ minWidth: 0 }}>
                    {editPad && role === "superdoctor" ? (
                        <input
                            ref={ref}
                            className={`body ${editPad ? "white" : ""}`}
                            value={institutionName}
                            onChange={e => setInstitutionName(e.target.value)}
                        />
                    ) : (
                        <div
                            className="body"
                            title={p.institution}
                            style={{ display: "block", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: "100%" }}
                        >
                            {p.institution}
                        </div>
                    )}

                    {role === "superdoctor" ? (
                        <div
                            title={"修改此床墊單位"}
                            className="w-50 bottomButton fx-center image-toggle cursor pt"
                            onClick={() => setEditPad(!editPad)}
                        >
                            <img className="w-20" src={comm_imgs.ICON_INFO_BASIC_2} alt={t("RESIDENTS.ENTER")} />
                            <img className="w-20" src={comm_imgs.ICON_INFO_BASIC_1} alt={t("RESIDENTS.ENTER")} />
                        </div>
                    ) : null}
                </div>
                {/* 編號 */}
                <div className={`flex-grow-1 body-container ${editNumber ? "editBg" : ""}`} onKeyDown={proccessNumber} style={{ minWidth: 0 }}>
                    {editNumber && role === "superdoctor" ? (
                        <input
                            ref={refNumber}
                            className={`body ${editNumber ? "white" : ""}`}
                            value={padNumberValue}
                            onChange={e => setPadNumberValue(e.target.value)}
                        />
                    ) : (
                        <div
                            className="body"
                            title={padNumberDisplay}
                            style={{ display: "block", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: "100%" }}
                        >
                            {padNumberDisplay}
                        </div>
                    )}
                    {role === "superdoctor" ? (
                        <div
                            title={"修改此編號"}
                            className="w-50 bottomButton fx-center image-toggle cursor pt"
                            onClick={() => setEditNumber(!editNumber)}
                        >
                            <img className="w-20" src={comm_imgs.ICON_INFO_BASIC_2} alt={t("RESIDENTS.ENTER")} />
                            <img className="w-20" src={comm_imgs.ICON_INFO_BASIC_1} alt={t("RESIDENTS.ENTER")} />
                        </div>
                    ) : null}
                </div>
                {/* 床號 */}
                <div className={`flex-grow-1 body-container ${editBedName ? "editBg" : ""}`} onKeyDown={proccessBedName} style={{ minWidth: 0 }}>
                    {editBedName && role === "superdoctor" ? (
                        <input
                            ref={refBedName}
                            className={`body ${editBedName ? "white" : ""}`}
                            value={bedName}
                            onChange={e => setBedName(e.target.value)}
                        />
                    ) : (
                        <div
                            className="body"
                            title={ConfigHandler.isIWard ? p.bed_name : p.first_name}
                            style={{ display: "block", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: "100%" }}
                        >
                            {ConfigHandler.isIWard ? p.bed_name : p.first_name}
                        </div>
                    )}
                    {role === "superdoctor" && ConfigHandler.isIWard ? (
                        <div
                            title={"修改此床號"}
                            className="w-50 bottomButton fx-center image-toggle cursor pt"
                            onClick={() => setEditBedName(!editBedName)}
                        >
                            <img className="w-20" src={comm_imgs.ICON_INFO_BASIC_2} alt={t("RESIDENTS.ENTER")} />
                            <img className="w-20" src={comm_imgs.ICON_INFO_BASIC_1} alt={t("RESIDENTS.ENTER")} />
                        </div>
                    ) : null}
                </div>
                {/* 受護者 */}
                <div className="flex-grow-1 body-container" style={{ minWidth: 0 }}>
                    <div
                        className="body"
                        title={p.last_name}
                        style={{ display: "block", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: "100%" }}
                    >
                        {p.last_name}
                    </div>
                </div>
                {/* 智慧墊 */}
                <div className="flex-grow-1 body-container">
                    <div className="body">{p.mac}</div>
                </div>
                {/* 智慧墊綁定-分配 */}
                <div className="flex-grow-1 body-container border-right-0">
                    <div
                        className="body button-assign cursor pt bg"
                        onClick={() => {
                            props.toggleAssignRes();
                            props.setPadSelectedInfo({ ...p, padNumber: padNumberDisplay });
                        }}>
                        {t("PAD.ASSIGN")}
                    </div>
                </div>
                {/* 智慧墊綁定-解綁 */}
                <div className="flex-grow-1 body-container">
                    <div
                        className="body button-unbind cursor pt"
                        onClick={() => {
                            if (p.last_name === undefined) return;
                            props.setPop({
                                open: true,
                                content:
                                    t("PAD.ARE_YOU_SURE_UNPAIR_SMART_PAD") +
                                    " 【" +
                                    p.mac +
                                    "】" +
                                    t("PAD.AND_RESIDENT") +
                                    "【" +
                                    p.last_name +
                                    "】" +
                                    t("PAD.AND_ASSIGN"),
                                parameter: [p.mac]
                            });
                        }}
                    >
                        {t("PAD.UNBIND")}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RowPads;
